import { render } from "./ProfilesList.vue?vue&type=template&id=74671ec5"
import script from "./ProfilesList.vue?vue&type=script&lang=js"
export * from "./ProfilesList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__